import React from 'react';
import { Grid, Skeleton, styled } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';

export const CircularSkeleton = styled(Skeleton)(({ width, height }) => ({
  animation: 'wave',
  width,
  height,
  background: '#DBDBDB0D, #DBDBDB',
}));

export const RoundedSkeleton = styled(Skeleton)(({ width, height }) => ({
  animation: 'wave',
  width,
  height,
  background: 'linear-gradient(270deg, rgba(219, 219, 219, 0.05) 0%, #DBDBDB 50%)',
  borderRadius: '21.25px',
}));

const LoadingSkeleton = () => (
  <Grid height="max-height" px="24px" py="12px">
    {[...Array(7)].map((_) => (
      <Grid
        key={uuidv4()}
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        mb={3}
      >
        <RoundedSkeleton variant="rounded" width={240} height={14.875} />
        <RoundedSkeleton variant="rounded" width={90} height={14.875} />
        <RoundedSkeleton variant="rounded" width={141} height={14.875} />
        <RoundedSkeleton variant="rounded" width={330} height={14.875} />
        <RoundedSkeleton variant="rounded" width={153} height={14.875} />
        <CircularSkeleton variant="circular" width={24} height={24} />
      </Grid>
    ))}
  </Grid>
);

export default LoadingSkeleton;
